export default __webpack_public_path__ + "static/Huobi_Logo Member TFA-1ffd7b792bf80ff5aa95f315651271f3.png";